module.exports = __webpack_public_path__ + "app-static/img/guide1.cbca5c87.png";